import styled from 'styled-components';

import colors from 'themes/Main';

const { white, gray01, gray03 } = colors;

export const Card = styled.div`
  cursor: default;
  min-width: 350px;
  border-radius: 3px;
  background-color: ${white};
  padding: 16px 32px;
  box-shadow: 0px 1px 3px rgba(219, 219, 219, 0.2),
    0px 2px 2px rgba(219, 219, 219, 0.12), 0px 0px 2px rgba(219, 219, 219, 0.14);

  + div {
    margin-left: 16px;
  }
`;

export const CardNumber = styled.h2`
  margin-bottom: 8px;
  font-size: 34px;
  font-weight: 700;
  color: ${gray01};
`;

export const CardDescription = styled.p`
  margin-bottom: 0;
  font-size: 20px;
  color: ${gray03};
  font-weight: 600;
`;
